const style = (theme) => {
  const output = {
    root: {
      extend: theme.wrapper,
      position: 'relative',
      background: theme.getRgba(theme.colors[2], 0.1),
      paddingTop: 80,
      paddingBottom: 80,
    },
    title: {
      position: 'relative',
      fontFamily: theme.fonts[1],
      color: theme.colors[0],
      fontWeight: 700,
      textTransform: 'uppercase',
      lineHeight: 1.1,
      fontSize: 'calc(40px + 2vw)',
    },
    section: {
      display: 'flex',
      flexDirection: 'column',
      gap: 40,
      '& li': {
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
        '& h3': {
          fontWeight: 700,
          color: theme.colors[0],
          textTransform: 'uppercase',
          paddingBottom: 10,
          marginBottom: 10,
          borderBottom: `1px solid ${theme.colors[0]}`,
        },
      },
    },
    items: {
      display: 'flex',
      flexDirection: 'column',
      gap: 15,
      '& a': {
        display: 'flex',
        textTransform: 'uppercase',
        alignItems: 'center',
        gap: 20,
        color: theme.colors[0],
        '&:hover': {
          textDecoration: 'underline',
        },
        '& span': {
          display: 'flex',
          alignItems: 'center',
          gap: 5,
          '& svg': {
            width: 20,
            height: 20,
            fill: theme.colors[0],
          },
        },
      },
    },
    logo: {
      position: 'relative',
      zIndex: 1,
      width: 80,
      height: 80,
      borderRadius: 8,
      overflow: 'hidden',
      background: theme.colors[1],
      flexShrink: 0,
      '& img': {
        width: '80%',
        height: '80%',
        position: 'absolute',
        zIndex: 1,
        left: '10%',
        top: '10%',
      },
    },
  }

  output[theme.mediaInverse.md] = {
  }

  output[theme.mediaInverse.sm] = {
    root: {
      paddingTop: 80,
      paddingBottom: 80,
    },
    title: {
      fontSize: 30,
    },
  }

  return output
}

export default style
